var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeechBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2956 0.744202H7.70493C3.45645 0.744202 0 4.12434 0 8.27902C0 12.4337 3.45645 15.8138 7.70493 15.8138H9.36668V18.6147C9.36668 18.6554 9.36801 18.6943 9.36908 18.7319V18.7361C9.36961 18.752 9.37015 18.7677 9.37068 18.7844C9.37148 18.8139 9.37068 18.8455 9.37015 18.8791C9.36855 18.953 9.36694 19.0365 9.38056 19.1271C9.39818 19.2415 9.43101 19.3903 9.53032 19.5279C9.66406 19.7124 9.87628 19.814 10.1285 19.814H10.1352C10.2655 19.8129 10.3944 19.7913 10.5081 19.7511C10.6205 19.7114 10.7225 19.6487 10.8031 19.5699L14.6512 15.805C18.7755 15.6209 22 12.323 22 8.27876C22 4.2345 18.5438 0.744202 14.2956 0.744202ZM10.2388 14.1668H7.70493C4.38516 14.1668 1.68418 11.5255 1.68418 8.27902C1.68418 5.03254 4.38489 2.39093 7.70493 2.39093H14.2956C17.6154 2.39093 20.3164 5.03228 20.3164 8.27902C20.3164 11.5258 17.6154 14.1668 14.2956 14.1668C14.0738 14.1668 13.8567 14.2548 13.7 14.4081L11.0746 16.9755L11.0808 14.9899C11.0808 14.5362 10.703 14.1671 10.2388 14.1671V14.1668Z",
    fill: "#726FB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubble);
export default __webpack_public_path__ + "static/media/speech-bubble.005a709aa61fb76962afaccdcefa30fe.svg";
export { ForwardRef as ReactComponent };